import { Component } from '@angular/core';

@Component({
  selector: 'notes-component',
  template: `<router-outlet></router-outlet>`,
  styles: `
    :host {
      @apply block h-full w-full;
    }
  `,
})
export class NotesComponent {}
